import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

interface Props {
  hasClockInSection: boolean
}

const BlockingBanner = ({ hasClockInSection }: Props) => {
  const { canManageSubscription } = useCurrentSession()
  const { navigation } = useNavigation()
  const current = companies.current

  const { pathname } = useLocation()

  const EXTRA_EXCLUDED_PAGES = current.headquarter == 'br' ? [navigation.clockIn.fullPath()] : []

  const EXCLUDED_PAGES = [navigation.settings.plans.fullPath(), ...EXTRA_EXCLUDED_PAGES]

  const hideBlockingBanner = EXCLUDED_PAGES.some((url) => pathname.includes(url))

  const customerPortalUrl = buildUrl('/customer-portal?v2')

  if (hideBlockingBanner) {
    return null
  }

  const props = canManageSubscription
    ? {
        title: i18n.t('billing.unpaid_invoices.blocking_banner.title'),
        description: i18n.t('billing.unpaid_invoices.blocking_banner.description'),
        footer: (
          <div
            style={{
              width: '100%',
              justifyContent: 'space-between',
              display: 'flex',
              flexDirection: 'row-reverse',
            }}
          >
            <Button.Router to={customerPortalUrl} type="primary">
              {i18n.t('billing.unpaid_invoices.blocking_banner.cta')}
            </Button.Router>
            {current.headquarter == 'br' && hasClockInSection && (
              <Button.Router to={navigation.clockIn.fullPath()} type="secondary">
                {i18n.t('sidebar.clock_in')}
              </Button.Router>
            )}
          </div>
        ),
      }
    : {
        title: i18n.t('billing.unpaid_invoices.blocking_banner.employee_title'),
        description: i18n.t('billing.unpaid_invoices.blocking_banner.employee_description'),
        ...(current.headquarter == 'br' && hasClockInSection
          ? {
              footer: (
                <Button.Router to={navigation.clockIn.fullPath()} type="secondary">
                  {i18n.t('sidebar.clock_in')}
                </Button.Router>
              ),
            }
          : {}),
      }

  return (
    <>
      <Modal
        locked
        illustration="alert"
        style={{
          marginTop: 'auto',
        }}
        disableFocusTrap
        {...props}
      ></Modal>
    </>
  )
}

export default BlockingBanner
